import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { logger } from '../utils/logger';

// Usa variáveis de ambiente quando disponíveis; caso contrário, faz fallback
// para a configuração conhecida do projeto (evita quebra em builds sem .env)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyC4Oy19YD021otKPHZrZZoaZ2BC5xp25ic',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'iat-consulting.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'iat-consulting',
  // Deve coincidir com o bucket no Console (ex.: iat-consulting.appspot.com). Upload no browser exige CORS no bucket — ver firebase/storage-cors.json
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'iat-consulting.appspot.com',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '145011075010',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:145011075010:web:3b3beeab085e8fe80cd85b',
  // Defina explicitamente a URL do RTDB se usar Realtime Database
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || 'https://iat-consulting-default-rtdb.firebaseio.com'
};

// Inicializa o Firebase apenas se não houver uma instância existente
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

// Site key do reCAPTCHA v3
const recaptchaKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
const isBrowser = typeof window !== 'undefined';
const isLocalhost = isBrowser && ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);
const isStaging = isBrowser && (
  window.location.hostname.includes('staging') || 
  window.location.hostname.includes('preview') ||
  window.location.hostname.includes('--iat-consulting') ||
  process.env.REACT_APP_ENV === 'staging'
);

// Inicializa App Check apenas no browser (evita erro em SSR ou testes)
if (isBrowser && !window.__FIREBASE_APPCHECK_INITIALIZED) {
  // eslint-disable-next-line no-console
  logger.log('[AppCheck] Ambiente detectado:', { isLocalhost, isStaging, hasRecaptchaKey: !!recaptchaKey });
  
  if (isStaging) {
    // Força modo debug em staging com token fixo
    // eslint-disable-next-line no-console
    logger.warn('[AppCheck] Staging detectado. Usando token de debug fixo.');
    // @ts-ignore
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = 'C57F46B8-1DEA-4C4E-93BA-81918DCC90AE'; // Token de debug fixo para staging
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider('debug'),
      isTokenAutoRefreshEnabled: true
    });
    window.__FIREBASE_APPCHECK_INITIALIZED = true;
  } else if (recaptchaKey) {
    // Produção: usa Site key
    // eslint-disable-next-line no-console
    logger.log('[AppCheck] Inicializando com reCAPTCHA v3.');
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(recaptchaKey),
      isTokenAutoRefreshEnabled: true
    });
    window.__FIREBASE_APPCHECK_INITIALIZED = true;
  } else if (isLocalhost) {
    // Localhost: modo debug
    // eslint-disable-next-line no-console
    logger.warn('[AppCheck] Localhost detectado. Ativando modo debug.');
    // @ts-ignore
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider('debug'),
      isTokenAutoRefreshEnabled: true
    });
    window.__FIREBASE_APPCHECK_INITIALIZED = true;
  } else {
    // eslint-disable-next-line no-console
    logger.warn('[AppCheck] Site key ausente e ambiente não é localhost/staging. App Check não inicializado.');
  }
}

export const auth = getAuth(app);
export const db = getFirestore(app);

// ✅ CORREÇÃO DE SEGURANÇA: Removido window.__FIREBASE_AUTH_FOR_MIGRATION__
// Auth não deve ser exposta globalmente — use auth importado diretamente
export const database = getDatabase(app);
export const storage = getStorage(app);

export default app; 